/**
 * 시간 포맷 처리
 * @param {number} seconds
 * @returns {string}
 */
export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const removeHyphens = (phone: string) => {
  return phone.replace(/-/g, '');
};

/**
 * 문자열 자르기
 * @param {string} str
 * @returns {string}
 */
export function truncateString(str: string): string {
  if (str.length <= 8) return str;
  return `${str.slice(0, 4)}...${str.slice(-4)}`;
}

/**
 * 줄바꿈 문자열을 HTML 태그로 변환
 * @param {string} srcString
 * @returns {string}
 */
export function replaceNewLineToTag(srcString: string): string {
  return srcString.replace(/\n/g, '<br />').replace(/\\n/g, '<br />');
}

/** 숫자만 남기고 모든 문자 제거하는 유틸리티 함수 */
export const cleanString = (str: string): string => {
  return str.replace(/[^0-9]/g, '');
};

/**
 * 숫자를 원화 형식으로 변환
 * @param {number} num
 * @returns {string}
 */
export function formatNumber(num: number): string {
  return num.toLocaleString('ko-KR');
}

/**
 * 파라미터에 +,- 가 있을 경우 제거해주는 함수
 * @param input
 * @returns
 */
export function removeSignPrefix(input: string) {
  if (typeof input !== 'string') {
    throw new Error('Input must be a string');
  }
  return input.startsWith('+') || input.startsWith('-') ? input.slice(1) : input;
}

/**
 * 파라미터에 'DBS, TRX'가 있을 경우 제거해주는 함수
 * @param input
 * @returns
 */
export function removeSymbol(input: string): string {
  if (typeof input !== 'string') {
    throw new Error('Input must be a string');
  }

  // 정규식을 사용하여 문자열에서 "DBS" 또는 "TRX"를 제거
  return input.replace(/\b(DBS|TRX)\b/g, '').trim();
}

/**
 * 로컬 환경일 경우 로컬 서버 주소 반환
 * @returns
 */
export function checklocal() {
  if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
    return 'http://localhost:3002';
  }
  return import.meta.env.VITE_API_URL_LOCAL;
}
